module.exports = __webpack_public_path__ + "static/img/basicmobilenew1.aa7dd953.png";